
import { useTranslation } from 'react-i18next';

import { Close } from '@app/components/icons/close';
import { useModal } from '@app/components/modal-views/context';
import CustomizeUrlUi from '@app/components/ui/customize-url-ui';
import { StandardFormDto } from '@app/models/dtos/form';


export interface ICustomizeUrlModalProps {
    url: string;
    form: StandardFormDto;
}

export default function CustomizeUrlModal({ url, form }: ICustomizeUrlModalProps) {
    const { t } = useTranslation();
    const { closeModal } = useModal();
    return (
        <div className="border-black-300 relative w-[calc(100vw-2rem)] max-w-[540px] rounded border border-black-300 bg-white p-6 text-left shadow-large sm:w-[540px] sm:p-8">
            <button
                onClick={closeModal}
                aria-label={t('BUTTON.CLOSE')}
                className="text-black-600 hover:bg-black-100 hover:text-black-800 absolute right-3 top-3 flex h-8 w-8 items-center justify-center rounded-md transition-colors"
            >
                <Close className="h-4 w-4" />
            </button>
            <CustomizeUrlUi url={url} form={form} />
        </div>
    );
}